import { AnnotazioneModificativa, SectionVM } from 'civil-status/view-models/step-form';

export const transformerAnnotazioneModificativa = (
  idEvento?: number,
  dataSection?: SectionVM
): AnnotazioneModificativa | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: {
      idEvento,
    },
    modifica: dataSection.changeSurname || undefined,
    descrizioneVecchioCognomeIntestatario: dataSection.oldSurnameRegistered || undefined || null,
    descrizioneNuovoCognomeIntestatario: dataSection.newSurnameRegistered || undefined || null,
    descrizioneVecchioNomeIntestatario: dataSection.oldNameRegistered || undefined || null,
    descrizioneNuovoNomeIntestatario: dataSection.newNameRegistered || undefined || null,
  };
};
